import { render } from "./IconChevronDown.vue.js?vue&type=template&id=a4c5a206!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconChevronDown.vue?vue&type=template&id=a4c5a206"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__